import { useState } from 'react';
import { Send, Globe2 } from 'lucide-react';
import { Card, CardHeader } from '@/components/ui/Card';
import { Input } from '@/components/ui/Input';
import { Button } from '@/components/ui/Button';
import { ToggleRow } from '@/components/ui/ToggleRow';
import { Alert } from '@/components/ui/Alert';
import { Table, TableHead, TableHeaderCell, TableBody } from '@/components/ui/Table';
import { EmptyState } from '@/components/ui/EmptyState';

/**
 * docs/IMPLEMENTATION_PLAN.md Feature 14, owner half. The single most
 * powerful action in the entire system — a real send here messages every
 * server the bot is in. Kept maximally explicit about that in the UI copy,
 * not just in code comments, per docs/ARCHITECTURE.md §4's requirement that
 * this endpoint carry the strongest permission verification of any in the app.
 */
export function AnnouncementsPage() {
  const [autoJoinEnabled, setAutoJoinEnabled] = useState(true);
  const [title, setTitle] = useState('');
  const [message, setMessage] = useState('');

  return (
    <div className="max-w-2xl space-y-6">
      <Alert
        tone="warning"
        title="This is the highest-risk action in the entire system"
        description="A real send here messages every server the bot is in. It stays disabled until live OWNER_IDS re-verification exists on every single request — not just at page load (docs/ARCHITECTURE.md §3.4)."
      />

      <Card>
        <CardHeader title="Auto-join welcome message" description="Sent once whenever the bot joins a new server." />
        <ToggleRow title="Enabled" checked={autoJoinEnabled} onChange={setAutoJoinEnabled} />
      </Card>

      <Card>
        <CardHeader title="Compose a broadcast" description="Sent only to servers that have opted in." />
        <div className="space-y-3">
          <div>
            <label className="text-small text-text-secondary block mb-1">Title</label>
            <Input value={title} onChange={(e) => setTitle(e.target.value)} placeholder="What's new in Dem" />
          </div>
          <div>
            <label className="text-small text-text-secondary block mb-1">Message</label>
            <textarea
              value={message}
              onChange={(e) => setMessage(e.target.value)}
              rows={4}
              className="w-full rounded-sm bg-bg-base border border-border-subtle px-3 py-2 text-body text-text-primary placeholder:text-text-tertiary focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-accent-management-500"
              placeholder="Announcement body..."
            />
          </div>
          <Button variant="destructive" disabled>
            <Send size={16} aria-hidden="true" />
            Send to all opted-in servers
          </Button>
        </div>
      </Card>

      <Card>
        <CardHeader title="Send history" action={<Globe2 size={18} className="text-text-tertiary" aria-hidden="true" />} />
        <Table>
          <TableHead>
            <TableHeaderCell>Sent</TableHeaderCell>
            <TableHeaderCell>Title</TableHeaderCell>
            <TableHeaderCell>Servers reached</TableHeaderCell>
          </TableHead>
          <TableBody />
        </Table>
        <div className="mt-2">
          <EmptyState icon={Globe2} title="No broadcasts sent yet" />
        </div>
      </Card>
    </div>
  );
}
